import React from 'react';

function TroubleInfo(props){
    return (
        <div className={"trouble-info trouble-border"}>
            <span className="title">{props.name}</span>
            <span className="right-arrow"/>
            <span className="roleName">{props.roleName}</span>
            <span className="code" style={{display:"none"}}>({props.code})</span>
            <span className="date" style={{display:"block"}}>{props.date}</span>
        </div>
    )
}


export default TroubleInfo;